<i18n>
{
	"en": {
		"customersReference": "Customers reference",
		"consigneeReference": "Consignee reference",
		"addReference": "Add reference"
	},
	"no": {
		"customersReference": "Kundes referanse",
		"consigneeReference": "Mottakers referanse",
		"addReference": "Legg til referanse"
	}
}
</i18n>

<template>
	<div class="other-references">

		<MultipleTextAreas
			:textAreas="textAreas"
			textAreaKeyToFocus="customersReference"
			:disabled="orderIsLocked"

			@textAreaChange="onTextAreaChange( $event.key, $event.value )"
		/>

	</div>
</template>

<script>
import {
	mapGetters,
	mapMutations,
	mapState
} from '../store/newOrder.store';
import {
	mapState as mapStateReferences,
	mapActions as mapActionsReferences,
	mapGetters as mapGettersReferences
} from '@/modules/references/store/references.store';
import MultipleTextAreas from '@/modules/newOrder/common/MultipleTextAreas';
import { i18n } from '@/core';

export default {
	name: 'OtherReferences',
	components: { MultipleTextAreas },

	computed: {
		...mapState(['order']),
		...mapStateReferences(['references']),
		...mapGettersReferences(['referenceCodeToReferenceMap']),
		...mapGetters(['orderIsLocked']),

		activeReferenceData() {
			return this.references.filter(
				reference => reference.isActive && !reference.isSystemReference
			);
		},

		otherReferences() { // additionalReferences can be either system-related or "other"-related
			let otherReferences = [];

			this.order.additionalReferences.forEach(
				ref => {
					let refData = this.referenceCodeToReferenceMap.get(ref.code);

					if (!refData || !refData.isSystemReference)
						otherReferences.push(ref);
				}
			);

			return otherReferences;
		},

		activeReferenceCodesToIndexMap() {
			let map = new Map();

			this.activeReferenceData.forEach(
				(ref, index) => map.set(ref.code, index)
			);

			return map;
		},

		textAreas() {
			let textAreasKeysToIndexMap = new Map();

			let textAreas = this.activeReferenceData.map(
				(ref, index) => {

					textAreasKeysToIndexMap.set( ref.code, index );

					return {
						key: ref.code,
						value: '',
						name: this.getTextAreaName(ref)
					};
				}
			);

			this.otherReferences.forEach(
				ref => {

					let index = textAreasKeysToIndexMap.get(ref.code);

					if (index === undefined) {

						let refData = this.activeReferenceData[this.activeReferenceCodesToIndexMap.get( ref.code )];

						let name;
						if (refData)
							name = this.getTextAreaName(refData);

						else
							name = this.getTextAreaName(ref);

						textAreas.push({
							key: ref.code,
							value: ref.value,
							name
						});

					} else {

						textAreas[index].value = ref.value;
					}
				}
			);
			return textAreas;
		},

		// TODO Matiseid: see if this should be removed, currently activating them on the database
		// You can always edit these references,
		// but note: there might also be references on a saved order with other codes than these, and they will also be
		// editable.
		allwaysAvailableReferenceCodes: () =>
			['customersReference', 'consigneeReference'],
	},

	created() {
		this.getReferences();
	},

	methods: {
		...mapMutations(['addAdditionalReference', 'setAdditionalReference']),

		...mapActionsReferences(['getReferences']),

		onTextAreaChange( code, value ) {

			let referenceIsNotInVuex = !this.otherReferences.find(
				otherReference => otherReference.code === code
			);

			if (referenceIsNotInVuex) this.addAdditionalReference(code);

			this.setAdditionalReference({ code, value });
		},

		getTextAreaName(referenceData) {

			if (i18n.locale === 'no' && referenceData.shortDescription && referenceData.shortDescription.no)
				return `${referenceData.shortDescription.no} (${referenceData.code})`;

			else if (i18n.locale === 'en' && referenceData.shortDescription && referenceData.shortDescription.en)
				return `${referenceData.shortDescription.en} (${referenceData.code})`;

			else return referenceData.code;
		}
	}
};
</script>

<style lang="scss" scoped>

.other-references {
	height: 100%;
	width: 100%;
	min-height: inherit;
}
</style>
